import type { Pt, Transform } from '@better-lights/core';

/**
 * Tier 3 — per-frame interaction state. Plain mutable data read by the render loop every
 * frame and written by pointer handlers; React never re-renders for it. Committed to the
 * document store at drag start / throttled previews / pointer up.
 */
export interface LiveDrag {
  pointerId: number;
  /** Run index in project order and its id. */
  run: number;
  runId: string;
  index: number;
  /** Live flat image-px points of the dragged run (with an inserted point). */
  live: number[];
  snapped: boolean;
  touch: boolean;
  lastPush: number;
}

export interface Live {
  transform: Transform;
  viewW: number;
  viewH: number;
  /** Hover ghost point (image px), Draw tool only. */
  hover: Pt | null;
  drag: LiveDrag | null;
  /** Freehand stroke in progress (image px). */
  stroke: Pt[] | null;
  /** Finger position of a loupe drag (screen px). */
  loupeAt: { sx: number; sy: number } | null;
  /** Compare divider x (CSS px). */
  compareX: number;
  fitAnim: { from: Transform; to: Transform; start: number } | null;
}

export function createLive(): Live {
  return {
    transform: { s: 1, tx: 0, ty: 0 },
    viewW: 0,
    viewH: 0,
    hover: null,
    drag: null,
    stroke: null,
    loupeAt: null,
    compareX: 0,
    fitAnim: null,
  };
}
